/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Mitch Wilson <mitchell.wilson@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const USER_FRAGMENT = gql`
  fragment User on User {
    id
    email
    firstName
    lastName
    username
    isActive
    phoneNumber
    phoneNumberVerified
    smsOptedOut
    jobTitle
    pinNumber
    isOwner
    isSuperuser
    tenant {
      id
      name
      logoImage {
        url
      }
      paymentCustomerId
    }
    groups {
      id
      name
      isOwner
      permissions {
        id
        codename
        name
        category
      }
      manageableRoles {
        id
        name
      }
    }
    stores {
      id
    }
    isStaff
    supervisor {
      id
      email
    }
    externalId
    dateJoined
    dateRemoved
    hasMultipleStores
    profileImage {
      url
    }
    activeSubscription
    onboardingComplete
    notificationSettings {
      posCriticalErrorsEnabled
    }
  }
`
